// Mirrors Kher.Domain.Domains.OrderEventType
export enum OrderEventType {
  // Order lifecycle
  OrderCreated = 1,
  OrderConfirmed = 2,
  OrderRejected = 3,
  OrderNotesUpdated = 4,
  OrderRecurringStopped = 5,

  // Payment
  PaymentInitiated = 100,
  PaymentSucceeded = 101,
  PaymentFailed = 102,
  PaymentRefunded = 103,

  // Verification stage
  VerificationStageCreated = 200,
  VerificationStageAssigned = 201,
  VerificationStageWaitingVerification = 202,
  VerificationStageProcessingFiles = 203,
  VerificationStageWaitingSendingTime = 204,
  VerificationStageVerified = 205,
  VerificationStageRejected = 206,
  VerificationStageReset = 207,
  VerificationStageSmsSent = 208,
  VerificationStagePrinted = 209,
  VerificationAttachmentAdded = 210,

  // Driver / supervisor attribution
  DriverAssignedToStage = 300,
  SupervisorAssignedToStage = 301,
}

export const orderEventTypeLabels: Record<OrderEventType, string> = {
  [OrderEventType.OrderCreated]: "إنشاء الطلب",
  [OrderEventType.OrderConfirmed]: "تأكيد الطلب",
  [OrderEventType.OrderRejected]: "رفض الطلب",
  [OrderEventType.OrderNotesUpdated]: "تحديث الملاحظات",
  [OrderEventType.OrderRecurringStopped]: "إيقاف التبرع المتكرر",

  [OrderEventType.PaymentInitiated]: "بدء عملية الدفع",
  [OrderEventType.PaymentSucceeded]: "نجاح الدفع",
  [OrderEventType.PaymentFailed]: "فشل الدفع",
  [OrderEventType.PaymentRefunded]: "استرداد المبلغ",

  [OrderEventType.VerificationStageCreated]: "إنشاء مرحلة التحقق",
  [OrderEventType.VerificationStageAssigned]: "تعيين مرحلة التحقق",
  [OrderEventType.VerificationStageWaitingVerification]: "بانتظار التحقق",
  [OrderEventType.VerificationStageProcessingFiles]: "معالجة الملفات",
  [OrderEventType.VerificationStageWaitingSendingTime]: "بانتظار وقت الإرسال",
  [OrderEventType.VerificationStageVerified]: "تم التحقق",
  [OrderEventType.VerificationStageRejected]: "رفض التحقق",
  [OrderEventType.VerificationStageReset]: "إعادة تعيين التحقق",
  [OrderEventType.VerificationStageSmsSent]: "إرسال رسالة نصية",
  [OrderEventType.VerificationStagePrinted]: "طباعة المرحلة",
  [OrderEventType.VerificationAttachmentAdded]: "إضافة مرفق",

  [OrderEventType.DriverAssignedToStage]: "تعيين سائق للمرحلة",
  [OrderEventType.SupervisorAssignedToStage]: "تعيين مشرف للمرحلة",
};

// Mirrors Kher.Domain.Domains.OrderActorType / Kher.Service.OrderEventTracking.Actors.ActorType
export enum ActorType {
  Anonymous = 0,
  Customer = 1,
  Admin = 2,
  Supervisor = 3,
  Driver = 4,
  System = 5,
}

export const actorTypeLabels: Record<ActorType, string> = {
  [ActorType.Anonymous]: "مجهول",
  [ActorType.Customer]: "عميل",
  [ActorType.Admin]: "مسؤول",
  [ActorType.Supervisor]: "مشرف",
  [ActorType.Driver]: "سائق",
  [ActorType.System]: "النظام",
};

export interface OrderEvent {
  id: number;
  eventType: OrderEventType;
  eventName: string;
  orderId: number;
  orderItemId: number | null;
  verificationStageId: number | null;
  cartId: number | null;
  actorType: ActorType;
  actorId: number | null;
  actorDisplayName: string | null;
  actorRole: string | null;
  occurredOn: string;
  payload: Record<string, unknown> | null;
}

export interface OrderActivityResponse {
  data: OrderEvent[];
  statusCode: number;
  isSuccess: boolean;
  totalItems: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  startPage: number;
  endPage: number;
}


export enum OrderLineType
{
  Project = 0,
  GiftProject = 1,
  FastOrder = 2,
  Classifications = 3,
}
export const orderLineTypeLabels: Record<OrderLineType, string> = {
  [OrderLineType.Project]: "مشروع",
  [OrderLineType.GiftProject]: "اهدا",
  [OrderLineType.FastOrder]: "صفحة التبرع السريع",
  [OrderLineType.Classifications]: "تبرع سريع",
};

export const orderLineTypeColors: Record<OrderLineType, string> = {
  [OrderLineType.Project]: "default",
  [OrderLineType.GiftProject]: "green",
  [OrderLineType.FastOrder]: "yellow",
  [OrderLineType.Classifications]: "dark",
};